import React from 'react';
import PropTypes from 'prop-types';
import {
  SUCCESS,
  DANGER,
  WARNING,
  INFO,
} from '../../constants/AlertTypes';

const alertTypeToTitleMap = {
  [SUCCESS]: 'Success',
  [DANGER]: 'Error',
  [WARNING]: 'Warning',
  [INFO]: 'Information',
};

class Alert extends React.Component {
  componentDidMount() {
    const {
      timeout,
      actions: {
        dismissAlert,
      },
    } = this.props;

    // If timeout is 0, no self disappear
    if (timeout && timeout > 0) {
      setTimeout(() => {
        dismissAlert(this.props.id);
      }, timeout);
    }
  }

  onClick = () => {
    this.props.actions.dismissAlert(this.props.id);
  };

  render() {
    const props = this.props;
    return (
      <div className={`alert alert-${props.type}`} onClick={this.onClick}>
        <button type="button" className="close">×</button>
        <h4>{alertTypeToTitleMap[props.type]}</h4>
        <p>{props.text}</p>
      </div>
    );
  }
}

Alert.propTypes = {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  timeout: PropTypes.number,
};

Alert.defaultProps = {
  timeout: 5000,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/shared/Alert.js